/* Old Soles per-colour gallery filter v3
 * Hides product gallery images whose filename colour doesn't match the currently-selected variant colour.
 * Works on both initial page load (with ?variant=X) and on colour-swatch clicks.
 * Matches colour slugs longest-first so NAVYWHITESOLE beats NAVY.
 *
 * v3 â€” two-phase approach to cooperate with Dawn's slider-component:
 *   Phase 1 (BEFORE Dawn): un-hide ALL slides so Dawn's scroll-to-featured-media can find its target.
 *   Phase 2 (AFTER Dawn):  re-apply the filter, snap scroll to first visible slide.
 * Also re-runs at 80ms and 400ms to catch late async updates from Dawn's fetch.
 */
(function () {
  var CLASS = 'os-hidden';

  function normalize(s) {
    return (s || '').toUpperCase().replace(/[\/\s\-,\.]/g, '');
  }
  function colourOf(filename, colours) {
    var fn = (filename || '').toUpperCase();
    var best = '', bestLen = 0;
    for (var i = 0; i < colours.length; i++) {
      var n = normalize(colours[i]);
      if (n && fn.indexOf(n + '_') !== -1 && n.length > bestLen) {
        best = colours[i];
        bestLen = n.length;
      }
    }
    return best;
  }
  function getColourOptions(root) {
    var radios = root.querySelectorAll('variant-radios input[type=radio], fieldset.product-form__input input[type=radio]');
    var map = {};
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var name = (r.name || '').toLowerCase();
      var fieldset = r.closest('fieldset');
      var legend = fieldset ? (fieldset.querySelector('legend') || {}).textContent || '' : '';
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || /colou?r/i.test(legend)) {
        map[r.value] = true;
      }
    }
    return Object.keys(map);
  }
  function getSelectedColour(root, colours) {
    if (!colours.length) return '';
    var checked = root.querySelectorAll('variant-radios input[type=radio]:checked, fieldset.product-form__input input[type=radio]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (colours.indexOf(checked[i].value) !== -1) return checked[i].value;
    }
    return colours[0];
  }
  function unhideAll(gallery) {
    var items = gallery.querySelectorAll('li[data-media-id]');
    for (var i = 0; i < items.length; i++) {
      items[i].hidden = false;
      items[i].classList.remove(CLASS);
      items[i].style.display = '';
    }
  }
  function applyFilter(root, snapScroll) {
    if (!root) return;
    var gallery = root.querySelector('slider-component[id^="GalleryViewer-"]');
    if (!gallery) return;
    var colours = getColourOptions(root);
    if (colours.length < 2) return;
    var selected = getSelectedColour(root, colours);
    var items = gallery.querySelectorAll('li[data-media-id]');
    var firstVisible = null;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var img = li.querySelector('img');
      var src = img ? (img.getAttribute('src') || '') : '';
      var fname = src.split('/').pop().split('?')[0];
      var c = colourOf(fname, colours);
      var shouldHide = !!(c && c !== selected);
      if (shouldHide) {
        li.hidden = true;
        li.classList.add(CLASS);
        li.style.display = 'none';
      } else {
        li.hidden = false;
        li.classList.remove(CLASS);
        li.style.display = '';
        if (!firstVisible) firstVisible = li;
      }
    }
    if (snapScroll && firstVisible) {
      try {
        // Snap the slider's inner UL to the first visible item
        var sliderList = gallery.querySelector('ul.slider, ul.product__media-list');
        if (sliderList) {
          // Jump (no smooth) so the image is immediately visible
          sliderList.scrollLeft = firstVisible.offsetLeft - sliderList.offsetLeft;
          // Notify Dawn's slider-component that scroll position changed
          sliderList.dispatchEvent(new Event('scroll', { bubbles: true }));
        }
        if (typeof firstVisible.scrollIntoView === 'function') {
          firstVisible.scrollIntoView({ behavior: 'auto', inline: 'start', block: 'nearest' });
        }
      } catch (e) {}
    }
  }
  function applyAll() {
    var roots = document.querySelectorAll('product-info, .product, main');
    for (var i = 0; i < roots.length; i++) applyFilter(roots[i], false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
  // PHASE 1: capture variant-picker clicks at the capture phase, BEFORE Dawn's handlers.
  // Un-hide all slides so Dawn's setActiveMedia can successfully scroll to the new featured media.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.closest && (t.closest('variant-radios label') || t.closest('.product-form__input label[for]'))) {
      var root = t.closest('product-info') || t.closest('.product') || t.closest('main') || document;
      var gallery = root.querySelector('slider-component[id^="GalleryViewer-"]');
      if (gallery) unhideAll(gallery);
    }
  }, true); // capture phase

  // PHASE 2: after Dawn's handlers complete, re-apply the filter and snap to the first visible slide.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.matches && t.matches('variant-radios input, variant-selects input, variant-selects select, fieldset.product-form__input input, fieldset.product-form__input select')) {
      var root = t.closest('product-info') || t.closest('.product') || t.closest('main') || document;
      // Run at multiple offsets to catch Dawn's async updates
      setTimeout(function () { applyFilter(root, true); }, 150);
      setTimeout(function () { applyFilter(root, true); }, 450);
      setTimeout(function () { applyFilter(root, true); }, 900);
    }
  });
})();
